import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { useApplicationModals } from "app/common/hooks";
import { useCollector, usePaginatedCollector } from "app/integration/common/hooks";
import MainLayout from "app/layouts/main";
import AppModals from "app/modals";
import CustomerPageTable from "./table";
import CustomerDetailSubPage from "./detail";

const breadcrumbItems = [{ label: "Customer", href: "/customer" }];

function CustomerPage() {
  const { openModal, setPayloads } = useApplicationModals();

  // const [customers, setCustomers, loader, collect, query, handleQueryChange] =
  //   useCustomerCollector();

  const [paramsCustomer, setParamsCustomer] = useState({
    search: "",
    status: null,
    id: null,
    page: 1,
    limit: 50,
    order: "first_name",
    sort: "ASC"
  });

  useEffect(() => {
    collectCustomers(paramsCustomer);
  }, [paramsCustomer]);

  const [
    customers,
    setCustomers,
    customersLoader,
    collectCustomers,
    customerPaginationProps,
  ] = usePaginatedCollector({ modelName: "customer", params: paramsCustomer });

  const [searchTimeout, setSearchTimeout] = useState(null);

  const handleCustomerSearch = (searchTerm) => {
    // Clear the previous timeout if it exists
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    // Set a new timeout to call the API after 3 seconds
    const timeout = setTimeout(() => {
      setParamsCustomer({ ...paramsCustomer, search: searchTerm });
    }, 1000);

    setSearchTimeout(timeout);
  };

  return (
    <MainLayout
      activeSidebarNavigation="customer"
      activeSidebarChild="customer"
      breadcrumbItems={breadcrumbItems}
      pageTitle="Customer"
      headingButtons={[
        {
          label: "Tambah Customer",
          type: "menuButton",
          onClick: () => openModal("customer.create"),
          items: [
            {
              label: "Tambah / Kurang Kredit",
              onClick: () => {
                setPayloads("credit.create", { customers });
                openModal("credit.create");
              },
            },
          ],
        },
      ]}
    >
      <AppModals
        items={["customer.create", "customer.delete"]}
        onSuccess={{
          "customer.create": () => collectCustomers(),
          "customer.delete": () => collectCustomers(),
        }}
      />
      <AppModals items={["credit.create"]} onSuccess={collectCustomers} />
      <Routes>
        <Route
          path="/"
          element={
            <CustomerPageTable
              customers={customers}
              onDeleteCustomerClick={(id) => {
                setPayloads("customer.delete", { id });
                openModal("customer.delete");
              }}
              query={paramsCustomer.search}
              onQueryChange={handleCustomerSearch}
              params={paramsCustomer}
              setParams={setParamsCustomer}
              customerPagination={customerPaginationProps}
            />
          }
        />
        <Route
          path="/detail/:id"
          element={
            <CustomerDetailSubPage
              customers={customers}
              query={paramsCustomer.search}
              onQueryChange={handleCustomerSearch}
            />
          }
        />
      </Routes>
    </MainLayout>
  );
}

export default CustomerPage;
